"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGINATION_DIRECTION = void 0;
var PAGINATION_DIRECTION;
(function (PAGINATION_DIRECTION) {
    PAGINATION_DIRECTION["DESC"] = "desc";
    PAGINATION_DIRECTION["ASC"] = "asc";
})(PAGINATION_DIRECTION = exports.PAGINATION_DIRECTION || (exports.PAGINATION_DIRECTION = {}));
//# sourceMappingURL=Pagination.js.map